import uploader_module from '@uploader/customer/store.js'
import core_waybills_module from '@core_waybills/customer/store.js'
import partitions_module from '@partitions/customer/store.js'
import operations_module from '@operations/customer/store.js'
import tool_data_card_module from '@toolbox/data_card/store.js'
import scanner_module from '@scanner/customer/store.js'

window.config = require('@config/config.js')
const CONFIG = new config()

const store = {
    namespaced: true,
    state: {
        /**
         * ========================================================================
         * Routes
         * ========================================================================
        **/
        routes: null,

        /**
         * ========================================================================
         * Theme & Config
         * ========================================================================
        **/
        is_can_use_scanner: true,
        service_config: {},

        /**
         * ========================================================================
         * Others
         * ========================================================================
        **/
        notifications: [],
        papers_label_infos: [],
        customer: null,
        customer_partitions: null,
        customer_operations: [],
        customer_operation: {},
    },
    getters: {
    },
    actions: {
        fetch_customer(context, payload) {
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_me).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    context.commit('set_customer', response.data.customer)
                })
                .catch(error => {
                    console.log('Failed to fetch customer.')
                })
        },
        fetch_routes(context, payload) {
            var url = new RestUrl(context.rootState.settings.customer.get_routes_url).parse(
                {},
                ""
            )

            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    var routes = response.data.routes
                    _.forEach(routes, (route, key) => {
                        routes[key] = CONFIG.lms_url + route
                    })

                    context.commit('set_routes', routes)
                    return Promise.resolve()
                })
                .catch(error => {
                    return Promise.reject("fetch_routes failed")
                    console.log('Failed to fetch routes.')
                })
        },
        fetch_notifications(context, payload) {
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_notifications).parse()

            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    context.commit('set_notifications', response.data.notifications)
                })
                .catch(error => {
                    console.log('Failed to fetch notifications.')
                })
        },
        fetch_papers_label_infos(context, payload) {
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_papers_label_infos).parse()
            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    console.log(response.data);
                    context.commit('set_papers_label_infos', response.data.label_infos)
                })
                .catch(error => {
                    console.log('Failed to fetch papers label infos.')
                })
        },
        fetch_current_customer_operations(context, payload) {
            var rest_url = new RestUrl(context.rootState.customer.routes.api_v1_customer_operations)
            var url = rest_url.parse(
                {},
                '?is_done=false&is_canceled=false&customer_identity='+context.state.customer.identity
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
            .then(response => {
                if (response.data.status == "success") {
                    context.commit('set_current_customer_operations', response.data.operations)
                }
            })
            .catch(error => {
                console.log('Failed to fetch customer operations.')
            })
        },
        set_current_customer_operation(context, payload) {
            context.commit('set_current_customer_operation', payload)
        },
        // fetch_customer_partitions(context, payload) {
        //     var url = new RestUrl(context.rootState.customer.routes.api_v1_provider_requested_partitions).parse(
        //         {},
        //         ""
        //     )
        //     return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
        //         .then(response => {
        //             context.commit('set_customer_partitions', response.data.partitions)
        //             return Promise.resolve()
        //         })
        //         .catch(error => {
        //             return Promise.reject("fetch_customer_partitions failed")
        //             console.log('Failed to fetch partitions.')
        //         })
        // },
    },
    mutations: {
        set_customer(state, payload) {
            state.customer = payload
        },
        set_routes(state, payload) {
            state.routes = payload
        },
        set_customer_partitions(state, payload) {
            state.customer_partitions = payload
        },
        set_current_customer_operations(state, payload) {
            state.customer_operations = payload
        },
        set_current_customer_operation(state, payload) {
            state.customer_operation = payload
        },
        set_notifications(state, payload) {
            state.notifications = payload
        },
        set_papers_label_infos(state, payload) {
            state.papers_label_infos = payload
        },
    },
    modules: {
        uploader_module,
        core_waybills_module,
        partitions_module,
        operations_module,
        tool_data_card_module,
        scanner_module,
    }
}

export default store
